import { Link } from "react-router-dom";
import { ArrowUpRight } from "lucide-react";
import { Reveal, ParallaxImage } from "@/components/Motion";
import { usePageMeta } from "@/lib/seo";

const CHAPTERS = [
  {
    n: "01", title: "The Venue",
    text: "Solis Casting is a venue, not an agency. Since 2011 we have kept one room open where models and the people who book them can find each other without gatekeepers. We don't take commission on bookings, we don't represent talent, and we don't promise employment — we keep the room honest, curated and open.",
  },
  {
    n: "02", title: "The Standard",
    text: "Every casting call is paid for and reviewed by our office before it reaches the board. Every model book shows real measurements, real frames and real credits. What you see is who arrives.",
  },
  {
    n: "03", title: "The Office",
    text: "Solis Casting is operated by Advent Studios LLC out of New York, NY 10012 — a small team that reads every posting, answers every enquiry, and believes the right face for the job is already out there, waiting to be found.",
  },
];

export default function About() {
  usePageMeta({
    title: "About — The Casting Venue | Solis Casting",
    description: "Solis Casting is the casting venue where houses, magazines and brands meet their next face — curated books, reviewed calls, no gatekeepers.",
    url: `${window.location.origin}/about`,
  });
  return (
    <div className="px-6 sm:px-10 py-24" data-testid="about-page">
      <Reveal>
        <p className="overline-label mb-4">The House</p>
        <h1 className="font-display font-light text-5xl sm:text-7xl tracking-tighter mb-20">
          About <span className="italic text-accent">Solis Casting</span>
        </h1>
      </Reveal>

      <div className="grid grid-cols-1 lg:grid-cols-12 gap-12 lg:gap-24 mb-32">
        <div className="lg:col-span-5">
          <Reveal>
            <ParallaxImage
              src="https://images.pexels.com/photos/14783478/pexels-photo-14783478.png?auto=compress&cs=tinysrgb&w=1000"
              alt="Inside a Solis Casting session"
              className="aspect-[4/5]"
              speed={8}
            />
          </Reveal>
        </div>
        <div className="lg:col-span-7 flex flex-col justify-center">
          {CHAPTERS.map((c, i) => (
            <Reveal key={c.n} delay={i * 0.08} className="mb-14 last:mb-0">
              <p className="font-display italic text-5xl text-white/15 mb-4">{c.n}</p>
              <h2 className="font-display font-light text-2xl sm:text-4xl tracking-tight mb-4">{c.title}</h2>
              <p className="text-muted-foreground leading-relaxed max-w-xl">{c.text}</p>
            </Reveal>
          ))}
        </div>
      </div>

      <Reveal className="border-t border-white/10 pt-16 flex flex-wrap gap-4">
        <Link to="/auth?mode=register&role=model" data-testid="about-model-cta" className="btn-primary">
          Join the talent board <ArrowUpRight size={16} />
        </Link>
        <Link to="/contact" data-testid="about-contact-cta" className="btn-outline">
          Talk to the office
        </Link>
      </Reveal>
    </div>
  );
}
